import React, { Component } from 'react';
import { Table } from 'react-bootstrap';
import OrganizationListRow from './OrganizationListRow';

export default class OrganizationList extends Component {

    constructor(props) {
        super(props);

        this.handleRemove = this.handleRemove.bind(this);
    }

    handleRemove(id) {
        this.props.onRemove(id);
    }

    getRows() {
        if (this.props.organizations.length === 0) return [];

        return this.props.organizations.map((o, i) => (
            <OrganizationListRow
                key={o}
                index={i}
                name={o}
                isLoading={this.props.isLoading}
                onRemove={this.handleRemove}
            />
        ));
    }

    render() {
        return (
            <Table className="organization-list" striped bordered hover size="sm">
                <thead>
                    <tr>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {this.getRows()}
                </tbody>
            </Table>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/CategoryView/OrganizationList.js